import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetWorkloadQuery } from "../../store/api/workloadApi";
import { useGetOrgQuery } from "../../store/api/orgApi";
import { useGetGvcQuery } from "../../store/api/gvcApi";
import { Org } from "../../schema/types/org/entity";
import { WorkloadDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";
import { useGvcContextNavigation } from "../../reactHooks/useGvcContextNavigation";

type RouteParams = "org" | "gvc" | "workload";
export const WorkloadDetailInitializer: React.FC = () => {
  const { org: orgName, gvc: gvcName, workload: workloadName } = useParams<RouteParams>();
  useGvcContextNavigation("workload");

  const selfLink = `/org/${orgName}/gvc/${gvcName}/workload/${workloadName}`;

  const { data: workload, isLoading, isFetching, isError, error, refetch } = useGetWorkloadQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  const { data: org, isLoading: isLoadingOrg, isError: isErrorOrg } = useGetOrgQuery(orgName, {
    skip: !orgName,
    refetchOnMountOrArgChange: true,
  });

  const gvcLink = `/org/${orgName}/gvc/${gvcName}`;
  const { data: gvc, isLoading: isLoadingGvc, isError: isErrorGvc } = useGetGvcQuery(gvcLink || "", {
    skip: !gvcLink,
    refetchOnMountOrArgChange: true,
  });

  if ((!workload && isLoading) || (!org && isLoadingOrg)) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="workload" />;
  }

  // Check specifically for 404 errors (resource deleted - not a temporary issue)
  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !workload || !org) {
    return <IncorrectItem canCreate={true} kind="workload" />;
  }

  return <WorkloadDetailForm org={org as Org} gvc={gvc} gvcName={gvcName!} workload={workload} />;
};
